
import numberWithCommas from '../lib/utils/designation-overview/utils.ts';

export const BENCHMARK = {
  AT: {
    classes: 'text-red-dark',
    icon: 'trending_flat',
    copy: 'At or Higher Than Median'
  },
  ABOVE: {
    classes: 'text-red-dark',
    icon: 'trending_up',
    copy: 'At or Higher Than Median'
  },
  BELOW: {
    classes: 'text-green-dark',
    icon: 'trending_down',
    copy: 'Lower Than Median'
  }
};

export const formatCost = cost => {
  const formattedCost = cost.toFixed(2);
  return numberWithCommas(`\$${formattedCost}`);
};
export const formatDifference = difference => {
  const formattedDif = formatCost(difference);
  return Number(difference) < 0 ? `(${formattedDif.replace(/-/, '')})` : formattedDif;
};

export const getBenchmark = (yourCost, benchmark) => {
  if (yourCost > benchmark) return BENCHMARK.ABOVE;
  else if (yourCost < benchmark) return BENCHMARK.BELOW;
  return BENCHMARK.AT;
};
